(function () {
  var COPY_SVG  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  // "-50% Rabatt mit dem Code [Summer50]" -> { text, code }
  function parse(raw) {
    raw = (raw || '').trim();
    if (!raw) return { text: '', code: '' };
    var code = '';
    var m = raw.match(/\[([^\]]+)\]/);
    if (m) code = m[1].trim();
    var text = raw.replace(/\[[^\]]*\]/, '').replace(/\s{2,}/g, ' ').trim();
    return { text: text, code: code };
  }

  // Führenden Prozentwert (z. B. "-50%") fett setzen
  function renderText(el, text) {
    el.textContent = '';
    var parts = text.match(/^(\S*\d+%\S*)\s+([\s\S]*)$/);
    if (parts) {
      var strong = document.createElement('strong');
      strong.textContent = parts[1];
      el.appendChild(strong);
      el.appendChild(document.createTextNode(' ' + parts[2]));
    } else {
      el.textContent = text;
    }
  }

  function resolveWrapper(form) {
    var scope = form && form.closest
      ? form.closest('[data-section-id], .product-single__meta, .product-template')
      : null;
    var w = scope ? scope.querySelector('[data-stoerer-wrapper]') : null;
    return w || document.querySelector('[data-stoerer-wrapper]');
  }

  function apply(wrapper, raw) {
    var box     = wrapper.querySelector('[data-stoerer]');
    var textEl  = wrapper.querySelector('[data-stoerer-text]');
    var codeEl  = wrapper.querySelector('[data-stoerer-code]');
    var copyBtn = wrapper.querySelector('[data-stoerer-copy]');
    if (!box) return;

    var data = parse(raw);
    if (!data.text && !data.code) { box.style.display = 'none'; return; }

    if (textEl) renderText(textEl, data.text);

    if (data.code && copyBtn && codeEl) {
      codeEl.textContent = data.code;
      copyBtn.setAttribute('data-code', data.code);
      copyBtn.style.display = '';
    } else if (copyBtn) {
      copyBtn.style.display = 'none';
    }
    box.style.display = '';
  }

  function flashCopied(btn) {
    var icon  = btn.querySelector('[data-stoerer-icon]');
    var label = btn.querySelector('[data-stoerer-code]');
    var prev;
    if (icon)  icon.innerHTML = CHECK_SVG;
    if (label) { prev = label.textContent; label.textContent = 'Kopiert!'; }
    setTimeout(function () {
      if (icon)  icon.innerHTML = COPY_SVG;
      if (label) label.textContent = prev;
    }, 1500);
  }

  function fallbackCopy(code, btn) {
    var ta = document.createElement('textarea');
    ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); flashCopied(btn); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-code') || '';
    if (!code) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { flashCopied(btn); }).catch(function () { fallbackCopy(code, btn); });
    } else {
      fallbackCopy(code, btn);
    }
  }

  // Klick auf das Code-Feld (Delegation -> überlebt Quick-View-Nachladen)
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-stoerer-copy]') : null;
    if (btn) { evt.preventDefault(); copyCode(btn); }
  });

  // Variantenwechsel (Impulse feuert variant:change mit der Varianten-JSON)
  document.addEventListener('variant:change', function (evt) {
    var v = evt.detail && evt.detail.variant;
    if (!v) return;
    var wrapper = resolveWrapper(evt.target);
    if (!wrapper) return;
    var mapEl = wrapper.querySelector('[data-stoerer-map]');
    if (!mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    apply(wrapper, map[v.id]);
  });
})();